import * as THREE from 'three';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js'
import { RGBELoader } from 'three/examples/jsm/loaders/RGBELoader.js'


let scene, camera, renderer;
let ambientLight, pointLight, directionalLight;
let width = window.innerWidth;
let height = window.innerHeight;

let plane;                             // Flieger
let ground;                            // Boden
let flightDir = 2;                     // Flugrichtung: 2=rechts 1=links
let scrollPosition;                    // eigentlich zwischen 0 und 1, 0 oben, 1 unten
let planeIntro = true;                 // true, bis der Introflug abgeschlossen ist
let planeFlying = true;                // true, wenn der Flieger noch nicht gelandet ist
let planePitch;                        // -1 = links 0 = Mitte 1 = rechts
let planeCatch = false;          //Flieger nach Introflug einfangen
let planeY;                            // "Soll"-Fliegerposition
let planeXspeed = 0.012;                // Geschwindigkeit in x-Richtung

let frameCount = null;
let planeYold = null;
let DeltaY;
let pitchFactor;


function setup() {
    // Canvas aus dem Html (DOM) holen
    const canvas = document.querySelector('canvas.webgl');

    // Scene: Das ist die Hierarchie aller 3D-Objekte, Kameras, Lichter, etc.
    scene = new THREE.Scene();

    // Camera
    initCamera();

    // Objekte erzeugen
    loadObjects();

    // Licht
    initLight();

    // Renderer
    renderer = new THREE.WebGLRenderer({
        canvas: canvas,
        alpha: true
    });
    renderer.setSize(width, height);
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
    renderer.shadowMap.enabled = true;
    renderer.shadowMap.type = THREE.PCFSoftShadowMap;
    renderer.setClearColor( 0xffffff, 1 );

    // Eventlisteners hinzufügen
    window.addEventListener('resize', onWindowResize);
    //window.addEventListener('dblclick', onDoubleClick);
    window.addEventListener('scroll', verticalFlight);
}

function animate() {
    // Ruf mich bei der nächsten Möglichkeit wieder auf
    requestAnimationFrame(animate);
    horizontalFlight();
    verticalFlight();
    frameCount += 1;
    

    // Renderer-Szene rendern
    renderer.render(scene, camera);
}

//Horizontale Bewegung
function horizontalFlight() {
    if(planeFlying === true){
        // x-Bewegung
        if(plane.position.y > 0.06){
            if(plane.position.x < 2 && flightDir == 2){
                plane.position.x += planeXspeed;
                }
            if (plane.position.x > 2 && flightDir == 2){
                flightDir = 1;
                planeXspeed = -planeXspeed;
                plane.rotation.y = toRadians(180);
                }

            if(plane.position.x > -2 && flightDir == 1){
                plane.position.x += planeXspeed;
                }
            if (plane.position.x < -2 && flightDir == 1){
                flightDir = 2;
                planeXspeed = -planeXspeed;
                plane.rotation.y = toRadians(0);
                }
            }
        else{
            planeFlying = false;
            plane.rotation.z = 0;
        }
    }
}

// Vertikale Bewegung
function verticalFlight(){

    scrollPosition = scale(window.scrollY,0,document.body.scrollHeight-window.innerHeight,0,1);
    if (scrollPosition > 1.097){ //glättet die maximale Scrollposition
        scrollPosition = 1.1;
    }
    camera.position.y = 12 - scale(scrollPosition,0,1.1,0,12); //hier war die Lösung für's Landen

    if(frameCount > 30){
    planeYold = plane.position.y;
    frameCount = 0;
    }

    // planeIntro (vorprogrammierte Flugbahn von y=12 bis y=10)
    planeY = 12 - scale(window.scrollY,0,document.body.scrollHeight-window.innerHeight,0,11.85);
        if(planeY < 10.1 && planeY > 9.9){
            planeY = 10;                            //Dient zum "Einfangen" des Fliegers mit der Kamera
        }
    
    if(planeIntro === true){

        // links bis Mitte
        if(flightDir === 2 && plane.position.x < 0){
            planePitch =  1 - scale(plane.position.x,-3,0,0,1); // 1 = 60 Grad 0 = 0 Grad
            plane.rotation.z = toRadians(-60 * planePitch);
            plane.position.y = plane.position.y - (0.008 * planePitch);
            }
        //Mitte bis Mitte rechts
        else if(flightDir === 2 && plane.position.x > 0 && plane.position.x < 1){
            planePitch =  scale(plane.position.x,0,1,0,1);
            plane.rotation.z = toRadians(30 * planePitch);
            plane.position.y = plane.position.y + (0.006 * planePitch);
            }
        //Mitte rechts bis rechts
        else if(flightDir === 2 && plane.position.x > 1){
            planePitch =  1 - scale(plane.position.x,1,2,0,1);
            plane.rotation.z = toRadians(30 * planePitch);
            plane.position.y = plane.position.y + (0.004 * planePitch);
        }
        //Rechts bis Mitte
        else if(flightDir === 1 && plane.position.x > 0){
            planePitch =  scale(plane.position.x,2,0,0,1);
            plane.rotation.z = toRadians(-40 * planePitch);
            plane.position.y = plane.position.y - (0.006 * planePitch);
            }
        //Mitte bis links
        else if(flightDir === 1 && plane.position.x < 0){
            planePitch =  1 - scale(plane.position.x,-2,0,1,0);
            plane.rotation.z = toRadians(-40 * planePitch);
            plane.position.y = plane.position.y - (0.006 * planePitch);
            }
        // Warteposition, bis Catch stattfindet
        if(plane.position.y < 10.1){        //Wenn die "Ist"-Flieger Position und die "Soll"-Fligerposition gleich ist
            plane.position.y = 10;
            plane.rotation.z = toRadians(0);
            planeIntro = false;
        }
    }

    // verticalFlightOnScroll
    else if(planeIntro === false){

        if(planeFlying === true){
            // PlaneCatch, Auffangen des Fliegers nach Introflug
            if(plane.position.y === planeY && planeCatch === false){
                plane.position.y = planeY;
                planeCatch = true;
            }

        else if(planeCatch === true){
            plane.position.y = 12 - scale(window.scrollY,0,document.body.scrollHeight-window.innerHeight,0,11.85);
            PlanePitch();
            if(plane.position.y < 0.2){
                plane.position.y = 0.05;
                planeFlying = false;
                plane.rotation.z = 0;
            }
            }
            console.log(plane.position.y);
            // console.log(document.body.scrollHeight);
            // console.log(window.scrollY);

        }
       
    
    }
}

function PlanePitch(){

        DeltaY = plane.position.y - planeYold;
        
        pitchFactor = scale(DeltaY,-6,6,-1,1) * scale(frameCount,0,30,1,0); // gradient bei Scrollen

        plane.rotation.z = toRadians(90 * pitchFactor);
}

function scale (number, inMin, inMax, outMin, outMax) {
    return (number - inMin) * (outMax - outMin) / (inMax - inMin) + outMin;
}

function loadObjects(){
    //loadGround(); // weißer Boden
    const loader = new GLTFLoader();
        loader.load(
            '/models/Paperplane/Paperplane.glb',
            function (gltf) {
                plane = gltf.scene;
                plane.receiveShadow = true;
                plane.castShadow = true;
                plane.position.set(-4.5, 13, 0);
                plane.rotation.x = toRadians(20);
                plane.scale.set(1.5,1.5,1.5);
                scene.add(plane);

                console.log('PlaneLoaded');
    
                plane.traverse((child) => {
                    if (child.isMesh) {
                        child.castShadow = true;
                        child.receiveShadow = true;
                    }
                });
});

loadGround();

/* loader.load('/models/Ground/Ground.glb', GroundLoaded); // grüner Boden (3D-Modell) */

}



function loadGround(){
    const geometry = new THREE.PlaneGeometry( 100, 100 );
    const material = new THREE.MeshStandardMaterial({ color: 0xffffff });
    ground = new THREE.Mesh( geometry, material );
    ground.position.set(0,0,0);
    ground.rotation.x = toRadians(-90);
    ground.receiveShadow = true;
    scene.add(ground);                  //Sorgt dafür, dass Ground Schatten empfängt
    console.log('GroundLoaded');
}


/*
function GroundLoaded(gltf){
    ground = gltf.scene;                //Szene die wir reinladen aus Blender
    ground.position.x = 0;
    ground.position.y = -0.1;
    ground.position.z = 0;
    ground.rotation.x = toRadians(0);
    ground.receiveShadow = true;

    ground.traverse(function(child) {
        if (child.isMesh) {
            child.receiveShadow = true; //Sorgt dafür, dass Ground Schatten empfängt
        }
    });

    scene.add(ground);
    ground.scale.set(1,1,1);
    console.log('GroundLoaded');
}
*/

function toRadians(degrees){
    return degrees * (Math.PI / 180);
}

function initCamera(){
    // vertikaler Winkel, Seitenverhältnis, near, far
    camera = new THREE.PerspectiveCamera(75, width / height, 0.01, 100);
    camera.position.z = 2;
    camera.position.y = 12;
    scene.add(camera);
}

function initLight(){
    ambientLight = new THREE.AmbientLight('rgb(255, 255, 255)', 1.0);
    scene.add(ambientLight);

    directionalLight = new THREE.DirectionalLight( 0xffffff, 5 );
    scene.add( directionalLight );
    directionalLight.castShadow = true;
    directionalLight.position.set( 5, 10, 10 );
    directionalLight.target.position.set( 0, 0, 0 );
    directionalLight.target.updateMatrixWorld()

    directionalLight.shadow.mapSize.width = 2048;  // größere Texturen für bessere Schattenqualität
    directionalLight.shadow.mapSize.height = 2048;
    directionalLight.shadow.camera.near = 0.5;    // Schatten-Distanz
    directionalLight.shadow.camera.far = 50;
    directionalLight.shadow.camera.left = -10;
    directionalLight.shadow.camera.right = 10;
    directionalLight.shadow.camera.top = 10;
    directionalLight.shadow.camera.bottom = -10;

    pointLight = new THREE.PointLight('rgb(255, 255, 255)', 30);
    pointLight.position.x = 0;
    pointLight.position.y = 5;
    pointLight.position.z = 2;
    pointLight.castShadow = false;
    scene.add(pointLight);
}


// callback für resize
function onWindowResize() {
    width = window.innerWidth;
    height = window.innerHeight;

    // Kamera an neue Fenstergröße anpassen
    camera.aspect = width / height;
    camera.updateProjectionMatrix();

    // Renderer an neue Fenstergröße anpassen
    renderer.setSize(width, height);
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
}

// callback für doubleclick
/* function onDoubleClick() {
    const canvas = document.querySelector('canvas.webgl');
    if (!document.fullscreenElement) {
        canvas.requestFullscreen();
    } else {
        document.exitFullscreen();
    }
}
*/

// Initiale Funktionen aufrufen
//if (window.innerWidth >= 1024) { //Ausführen nur auf Desktop
    setup();
    animate();
//}